import React from 'react';
import PropTypes from 'prop-types';
import '../assignments.scss';
import Modal from '../../../components/Modal';
import {useGetPreviewAssignmentInfoMutation} from '../../../features/authentication/assignmentApislice';
import { useGetQuestionByIdMutation } from '../../../features/authentication/assignApiSlice';
import { useAssignmentContext } from '../context';
import QuestionDetail from './QuestionDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import AssignmentPreviewHeader from './AssignmentPreviewHeader';
import QuestionPreviewTypes from '../../../enums/questionPreviewTypes';
import { DateFormatter } from '../../../utils/DateFormatter';

const AssignmentPreviewModal = ({
  isOpen,
  onClose
}) => {
  const Ids = useParams();
  const assignment = useAssignmentContext();
  const Id = assignment?.assignmentId
    ? assignment?.assignmentId
    : Ids.Id
      ? Ids.Id
      : Ids.assignmentId;

  const [selectedQuestionIndex, setSelectedQuestionIndex] = React.useState(0);
  const [getPreviewAssignmentInfo] = useGetPreviewAssignmentInfoMutation();
  const [getQuestionDetailsById] = useGetQuestionByIdMutation();
  const [assignmentInfo, setAssignmentInfo] = React.useState({});
  const [questionDetails, setQuestionDetails] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(0);
  const [qSetChange, setQSetChange] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [setHtmlContentUrl] = React.useState('');
  const PAGE_SIZE  = 24;
  const questionCount = assignmentInfo?.questionIds?.length;
  const numPages = Math.ceil(questionCount / PAGE_SIZE);
  const startIndex = currentPage * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const pageQuestionIds = assignmentInfo?.questionIds?.slice(startIndex, endIndex);

  React.useEffect(() => {
    if (isOpen) {
      getPreviewDetails();
    }
  }, [isOpen]);

  async function getPreviewDetails()
  {
    const option = { assignmentId: Id };
    const response = await getPreviewAssignmentInfo(option).unwrap();
    setAssignmentInfo(response);
    getQuestionDetailsByIdHandler(response.questionIds[0],0);
  }

  React.useEffect(() => {
    if(assignmentInfo?.questionIds?.length>0 && startIndex < assignmentInfo?.questionIds?.length)
    {
      getQuestionDetailsByIdHandler(assignmentInfo.questionIds[startIndex],startIndex);
    }
  }, [qSetChange]);

  const getQuestionDetailsByIdHandler = async (questionId, index) => {
    if(!questionId)
      return;

    setIsLoading(true);
    setSelectedQuestionIndex(index);
    let option = { assignmentId: Id, questionId: questionId, languageId: 0 };
    try {
      const response = await getQuestionDetailsById(option).unwrap();
      setQuestionDetails(response);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  };

  function handlePrevPage() {
    setCurrentPage(currentPage - 1);
    setQSetChange(!qSetChange);
  }

  function handleNextPage() {
    setCurrentPage(currentPage + 1);
    setQSetChange(!qSetChange);
  }

  const nextQuestionHandler = () => {
    const modalContentEl = document.querySelector('.modal-details');
    const firstQuestionEl = modalContentEl.querySelector('p');
    firstQuestionEl?.scrollIntoView({ behavior: 'smooth', top: '0' });

    if (selectedQuestionIndex < assignmentInfo?.questionIds?.length - 1) {
      
      getQuestionDetailsByIdHandler(assignmentInfo?.questionIds[selectedQuestionIndex + 1], selectedQuestionIndex + 1);
    }
    if (endIndex === selectedQuestionIndex + 1) setCurrentPage(currentPage + 1);
  };

  const previousQuestionHandler = () => {
    const modalContentEl = document.querySelector('.modal-details');
    const firstQuestionEl = modalContentEl.querySelector('p');
    firstQuestionEl?.scrollIntoView({ behavior: 'smooth', top: '0' });

    if (selectedQuestionIndex != 0) {
      
      getQuestionDetailsByIdHandler(assignmentInfo?.questionIds[selectedQuestionIndex - 1], selectedQuestionIndex - 1);
    }
    const page = Math.round(selectedQuestionIndex/PAGE_SIZE);
    if(page > 0)
      setCurrentPage(page - 1);
  };

  const resetCurrentPage = () => {
    setCurrentPage(0);
  };
   
  return (
    <Modal
      isOpen={isOpen}
      titleName={`${assignmentInfo?.isAssessment? 'Assessment' : 'Assignment'} Preview`}
      onClose={() => {
        onClose();
        resetCurrentPage();
      }}
      contentWidth="100%">
      <>
        <AssignmentPreviewHeader
          assignmentName = {assignmentInfo?.assignmentName}
          numberOfQuestions={`${selectedQuestionIndex + 1}/${assignmentInfo?.questionIds?.length ? assignmentInfo?.questionIds?.length : ''}`}
          courseName={assignmentInfo?.courseName}
          verificationNumber={assignmentInfo?.verificationNumber}
          type={QuestionPreviewTypes.assignmentPreview}
          createdDate ={assignmentInfo?.createdDate !== undefined ? DateFormatter.toShortDate(assignmentInfo?.createdDate) : ''}
          isAssessment= {assignmentInfo?.isAssessment}
        />
        <div className="assignment-review-content d-flex align-items-start gap-4 mb-2">
          <div className="questions-numbers flex-shrink-0">
            <div className="d-flex justify-content-between">
              <h4 style={{ paddingTop: '10px' }}>Questions</h4>
              {numPages > 1 && (
                <div className='d-flex gap-2 mb-3'>
                  <div
                    onClick={()=>handlePrevPage()}
                    className={`btn p-3 border-0 bg-orangelite ${currentPage === 0 ? 'disabled text-grey' : 'text-castleOrange cursor-pointer'
                    }`}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </div>
                  <div
                    onClick={()=>handleNextPage()}
                    className={`btn p-3 border-0 bg-orangelite ${currentPage === numPages - 1 ? 'disabled text-grey' : 'text-castleOrange cursor-pointer'
                    }`}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              )}
            </div>
            <ul className="d-flex flex-wrap m-0 p-0 gap-2">
              {pageQuestionIds?.map((questionId, index) => {
                const questionIndex = startIndex + index;
                return (
                  <li
                    style={{ cursor: 'pointer' }}
                    key={questionIndex}
                    onClick={() => getQuestionDetailsByIdHandler(questionId,questionIndex)}
                    className={`${selectedQuestionIndex == questionIndex && 'active'} question-list-item`}>
                    <a>{questionIndex + 1}</a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="d-flex flex-column w-75">
            <QuestionDetail
              questionDetails={questionDetails}
              setQuestionDetails={setQuestionDetails}
              nextQuestionHandler={nextQuestionHandler}
              selectedQuestionId={selectedQuestionIndex}
              lastQuestion={questionCount === selectedQuestionIndex + 1 ? true : false}
              isLoading={isLoading}
              setHtmlContentUrl={setHtmlContentUrl}
              assignmentId={Id}
              type={QuestionPreviewTypes.assignmentPreview}
              assignmentDetails={assignmentInfo}
              isFirstQuestion={selectedQuestionIndex == 0}
              previousQuestionHandler={previousQuestionHandler}
            />
          </div>
        </div>
      </>
    </Modal>      
  );
};

AssignmentPreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default AssignmentPreviewModal;
